export const subtitles = {
    "1": {
        "startTime": 0.0,
        "endTime": 3.0,
        "transcript": "[Au͡g]na Qakianaq tangtullruaqa tan'gaurluulua avani.",
        "translation": "I used to see Qakianaq back when I was a boy."
    },
    "2": {
        "startTime": 4.0,
        "endTime": 11.0,
        "transcript": "Luqinqum, kipusvigluni kanani angukara'urluq Luqinqumek pitullrat Kass'aq.",
        "translation": "Luqinquq, the old Caucasian man they called Luqinquq had a store down there."
    },
    "3": {
        "startTime": 12.0,
        "endTime": 18.0,
        "transcript": "Kitak' nutaan wani murilkengllerpenek, murilkengllerpenek ayagluten",
        "translation": "So now, since you became observant, starting when you became observant"
    },
    "4": {
        "startTime": 19.0,
        "endTime": 24.0,
        "transcript": "man'a Urucaraq, Urucarami yuurtellren kinguakun murilkengllerpeni",
        "translation": "Urucaraq here, from what you have observed after you were born in Urucaraq"
    },
    "5": {
        "startTime": 24.5,
        "endTime": 30.0,
        "transcript": "Mamterillrem una tekilluku anglillra cimingellra-llu qanemcikqerru.",
        "translation": "Talk about how Bethel here has grown and changed to this day."
    },
    "6": {
        "startTime": 31.5,
        "endTime": 35.0,
        "transcript": "Murilkellemni-w' ava-i tua-i ava-i ayagnirluku piyaaqekemken.",
        "translation": "I just started off by telling you about what I observed."
    },
    "7": {
        "startTime": 36.0,
        "endTime": 37.9,
        "transcript": "Yaa, kan'a wani ayaksaitellruuq.",
        "translation": "Yes,[but] the [device] down there wasn't going."
    },
    "8": {
        "startTime": 38.0,
        "endTime": 40.0,
        "transcript": "Nutaan, nutaan tua-i wani ayagninqigtellruuq.",
        "translation": "Just now, it's just started again now."
    },
    "9": {
        "startTime": 40.5,
        "endTime": 43.0,
        "transcript": "Tua-i-w' au͡g'umek qasgimek apcavnga.",
        "translation": "You asked me about that community house."
    },
    "10": {
        "startTime": 44.0,
        "endTime": 47.9,
        "transcript": "Qasgiq au͡gna napaluku murilkellruaqa.",
        "translation": "I observed that community house when it was standing."
    },
    "11": {
        "startTime": 48.0,
        "endTime": 50.9,
        "transcript": "Cali tamaani maqiaqata-wa",
        "translation": "And back when they took fire baths"
    },
    "12": {
        "startTime": 51.0,
        "endTime": 55.0,
        "transcript": "maqirraarluteng waten egalirqata ullalallruaput iterluta.",
        "translation": "When they covered the smoke hole after they took fire baths like this, we would go in and see them."
    },
    "13": {
        "startTime": 56.0,
        "endTime": 62.0,
        "transcript": "Taq'aqameng angukaralleraat qasgim iluani qanengssaaratuata.",
        "translation": "Because when they were finished, the old men would talk inside the community house."
    },
    "14": {
        "startTime": 62.5,
        "endTime": 63.9,
        "transcript": "Cali-llu kiirceńani.",
        "translation": "It was also hot."
    },
    "15": {
        "startTime": 64.0,
        "endTime": 68.0,
        "transcript": "Waten uksumi-llu piaqameng, maqinerra'arqameng assirluni tua-i kiirceńani.",
        "translation": "And when they had just taken fire baths in the winter like this, it was nice and hot."
    },
    "16": {
        "startTime": 72.0,
        "endTime": 77.0,
        "transcript": "Ullagyulalput waniwa angukarallret qanengssaarallrata, qanengssaalallrata pilall'.",
        "translation": "When these old men that we liked to go see started talking, they started talking."
    },
    "17": {
        "startTime": 79.0,
        "endTime": 81.0,
        "transcript": "Niicugniyarturluki niitnirqessuata.",
        "translation": "We would go listen to them because they were pleasant."
    },
    "18": {
        "startTime": 81.5,
        "endTime": 89.0,
        "transcript": "Tau͡gaam wiinga puqialama tamakut qanengssak'lallrit nalluyagulluki [tuatiilaranka].",
        "translation": "But because I'm inarticulate, I forget what they said [?]."
    },
    "19": {
        "startTime": 90.0,
        "endTime": 92.0,
        "transcript": "Qaillun egalilallruat?",
        "translation": "How would they cover the smoke hole?"
    },
    "20": {
        "startTime": 93.0,
        "endTime": 94.0,
        "transcript": "Egalilallruat-qaa?",
        "translation": "You mean how they covered the smoke hole?"
    },
    "21": {
        "startTime": 95.0,
        "endTime": 105.0,
        "transcript": "Tua-i-wa maqilriit taq'aqata kan'a maqillerteng tayima qam'aqan iliit egalilartuq.",
        "translation": "When they finished taking fire baths, when the fire down there was going out, one of them would cover the smoke hole."
    },
    "22": {
        "startTime": 106.0,
        "endTime": 108.0,
        "transcript": "Egalra qasgim patuluku.",
        "translation": "They would cover the smoke hole of the community house."
    },
    "23": {
        "startTime": 109.0,
        "endTime": 117.0,
        "transcript": "Nutaan-ll' paturraarluku tua-i imkut angutet matarrarmeng waten itraqamta uitauralartut.",
        "translation": "And after they closed it, those men would be naked like this when we entered."
    },
    "24": {
        "startTime": 117.5,
        "endTime": 118.9,
        "transcript": "Akluksaunateng.",
        "translation": "They hadn't put on clothes."
    },
    "25": {
        "startTime": 119.0,
        "endTime": 120.8,
        "transcript": "Tua-i kinercirraarluteng pilallilriit.",
        "translation": "It was probably after they had dried off."
    },
    "26": {
        "startTime": 122.0,
        "endTime": 128.0,
        "transcript": "Ukut tua-i Aagurmiut Urucararmiut-llu ataucimek qasgingqertut.",
        "translation": "These settlements, Aagurmiut and Urucararmiut, had one community house."
    },
    "27": {
        "startTime": 130.0,
        "endTime": 136.0,
        "transcript": "Iliini waten uksumi ukut Aagurmiut maqiyunglliniaqameng",
        "translation": "Sometimes in the winter, probably when Aagurmiut wanted to take fire baths"
    },
    "28": {
        "startTime": 138.0,
        "endTime": 144.0,
        "transcript": "Qamuutara'arluteng muragmek uciluteng ikamrarluteng malikurluteng qasgimun aglartut.",
        "translation": "They would drag sleds with wood inside and go to the community house together."
    },
    "29": {
        "startTime": 144.8,
        "endTime": 146.0,
        "transcript": "Unaggun Kepenkuullrani un'a",
        "translation": "Down there through Kepenkuk"
    },
    "30": {
        "startTime": 147.0,
        "endTime": 151.0,
        "transcript": "Kepenkugkun tua-i yaavet qasgimun agluteng",
        "translation": "They would go over there to the community house through Kepenkuk"
    },
    "31": {
        "startTime": 151.5,
        "endTime": 157.0,
        "transcript": "Ataucimek qasgingqerrameng ukut Urucararmiut kiaqliit-ll' ukut Aagurmiunek pitullrit.",
        "translation": "Because Urucararmiut and what they called Aagurmiut upriver from them had one community house."
    },
    "32": {
        "startTime": 157.5,
        "endTime": 160.0,
        "transcript": "Aagurmiunguyaaqut kankut waniwa.",
        "translation": "The [settlement] down there is actually Aagurmiut."
    },
    "33": {
        "startTime": 163.0,
        "endTime": 165.0,
        "transcript": "Tua-i quyurrluteng imkut yuut",
        "translation": "Those people would gather"
    },
    "34": {
        "startTime": 168.0,
        "endTime": 175.0,
        "transcript": "Yuungatellruameng waten inglukuurutevkenateng, allakuakutevkenateng.",
        "translation": "Because it seemed that they lived like this without animosity toward each other or discrimination."
    },
    "35": {
        "startTime": 175.1,
        "endTime": 181.0,
        "transcript": "Ilateng-llu tua-i qaillun piaqan ikayualuku pitullruameng yullret au͡gkut.",
        "translation": "And because those people of old would help when one of them came to some misfortune."
    },
    "36": {
        "startTime": 182.0,
        "endTime": 185.0,
        "transcript": "Camek akimek nunuliutmek-llu pivkenateng.",
        "translation": "They wouldn't ask for money or a reward."
    },
    "37": {
        "startTime": 185.5,
        "endTime": 189.0,
        "transcript": "Atunem tua-i ikayualluteng tangvakallemni-wa.",
        "translation": "They helped each other from what I've seen."
    },
    "38": {
        "startTime": 191.0,
        "endTime": 192.9,
        "transcript": "Murilkellemni tua-i ava-i qanrutamken.",
        "translation": "Murilkellemni tua-i ava-i qanrutamken."
    },
    "39": {
        "startTime": 193.0,
        "endTime": 204.0,
        "transcript": "Qasgiq pingna, kana-i ug'um Joe Lomack-am building-aam nuniini wani",
        "translation": "The community house inland, down around Joe Lomack's building downriver"
    },
    "40": {
        "startTime": 204.1,
        "endTime": 206.0,
        "transcript": "Kellirneneraani egkua uitallruuq.",
        "translation": "Its back wall was toward the water from there."
    },
    "41": {
        "startTime": 208.0,
        "endTime": 214.9,
        "transcript": "Urucaramek pitullrat nanvauvkenani tua-i kinerrluni tau͡gaam kuigluni.",
        "translation": "The one they used to call Urucaraq wasn't a lake, it was dry but had a river."
    },
    "42": {
        "startTime": 216.0,
        "endTime": 219.0,
        "transcript": "Kuiga-ll' tauna tua-i bridge-aq unaggun",
        "translation": "And its river, the bridge down there"
    },
    "43": {
        "startTime": 220.0,
        "endTime": 227.0,
        "transcript": "Ama-i elitnaurvilleq ciuqliq qamani, qamani Moravian-at agayuviim-wa yaatiini",
        "translation": "That first schoool uprver, upriver over from the Moravian church"
    },
    "44": {
        "startTime": 227.5,
        "endTime": 228.5,
        "transcript": "Yaa, agayuvillrem",
        "translation": "Yes, the old church"
    },
    "45": {
        "startTime": 228.9,
        "endTime": 235.0,
        "transcript": "Tuss'arartangqellruuq tua-i tuskanek kanavet Aagurmiunun tekilluni.",
        "translation": "There were steps made of boards reaching down to Aagurmiut."
    },
    "46": {
        "startTime": 235.5,
        "endTime": 237.0,
        "transcript": "Wagg'uq uumun Luqinqumun.",
        "translation": "That is, to this Luqinquq."
    },
    "47": {
        "startTime": 238.0,
        "endTime": 240.0,
        "transcript": "Luqinquq kipusvigluni tuani.",
        "translation": "Luqinquq had a store there."
    },
    "48": {
        "startTime": 242.0,
        "endTime": 245.0,
        "transcript": "Aiparluni au͡g'umek Kass'amek ketiini eneluni.",
        "translation": "He had a Caucasian partner who had a house toward the water from him."
    },
    "49": {
        "startTime": 245.5,
        "endTime": 247.9,
        "transcript": "Paatnaqlikiit-wa tamatum nalliini.",
        "translation": "Those were partners in those days."
    },
    "50": {
        "startTime": 248.0,
        "endTime": 249.9,
        "transcript": "Wagg'uq una Kassaussaaq.",
        "translation": "They called him Kassaussaaq [Trying to be Caucasian]."
    },
    "51": {
        "startTime": 251.9,
        "endTime": 256.9,
        "transcript": "Au͡gkut yull'urluut tua-i aciayuameng piciatun ayuqaitnek.",
        "translation": "Those people of old were good at giving various names suited for them."
    },
    "52": {
        "startTime": 260.0,
        "endTime": 262.0,
        "transcript": "Tamaa-i tua-i ellangellruunga",
        "translation": "In my earliest memories back then"
    },
    "53": {
        "startTime": 265.0,
        "endTime": 269.0,
        "transcript": "Ukut tua-i Kass'at maani akuliitni",
        "translation": "There were Caucasians in between here"
    },
    "54": {
        "startTime": 269.5,
        "endTime": 274.9,
        "transcript": "Ukut Aagurmiut Urucaram-llu akuliitni amllerpek'nateng tua-i.",
        "translation": "In between Aagurmiut and Urucaraq, but not a lot."
    },
    "55": {
        "startTime": 275.0,
        "endTime": 277.9,
        "transcript": "Kenirkauya'rmek-llu qanlalriit ava-i.",
        "translation": "They also talked about Kenirkauyar back then."
    },
    "56": {
        "startTime": 278.0,
        "endTime": 283.9,
        "transcript": "Tauna-ll' Kenirkauyar maani agnguarviulallruuq.",
        "translation": "Kenirkauyar there was a [Western] dancing hall here."
    },
    "57": {
        "startTime": 284.0,
        "endTime": 289.0,
        "transcript": "Tau͡gaam piciatun pivkenateng waten, Maqinermi tau͡gaam.",
        "translation": "But they didn't do it at random [times] like this, only on Saturday."
    },
    "58": {
        "startTime": 290.0,
        "endTime": 295.5,
        "transcript": "Cali-llu 12 clock un' tekilluku.",
        "translation": "It also went until 12 o'clock."
    },
    "59": {
        "startTime": 295.5,
        "endTime": 297.5,
        "transcript": "Taum tua-i taqevkalarai.",
        "translation": "That was when they stopped."
    },
    "60": {
        "startTime": 298.0,
        "endTime": 300.0,
        "transcript": "Kesianek-llu aquivkarpek'nata.",
        "translation": "And they wouldn't let us frolick all the time."
    },
    "61": {
        "startTime": 302.0,
        "endTime": 304.9,
        "transcript": "Unuk quka'arqan utercet'laraitkut nunamteńun.",
        "translation": "At midnight, they would tell us to return to our villages."
    },
    "62": {
        "startTime": 305.0,
        "endTime": 307.9,
        "transcript": "Inerqualuta-llu tarritesqevkenata.",
        "translation": "They also admonished us against wandering about."
    },
    "63": {
        "startTime": 308.0,
        "endTime": 313.0,
        "transcript": "Tang au͡gkut makut Kass'at-llu au͡gkut ciuqliit",
        "translation": "You see, these first Caucasians back then"
    },
    "64": {
        "startTime": 313.5,
        "endTime": 318.9,
        "transcript": "Makutun Yugtun ikayuasnganateng atunem ayuqellrullinilriit tamaani.",
        "translation": "They also apparently helped each other back then like Yupiit."
    },
    "65": {
        "startTime": 320.0,
        "endTime": 329.0,
        "transcript": "Wangkuta Yuungramta tua-i-wa iliini Kassaunge'rmeng inerquqa'aqluta pitullruut.",
        "translation": "Even though we were Yup'ik, sometimes even Caucasians would admonish us."
    },
    "66": {
        "startTime": 331.0,
        "endTime": 336.0,
        "transcript": "Cali-llu wiingau͡rluq waniwa inerciigatarkaunge'rma",
        "translation": "Also, even though I was to be mischievous"
    },
    "67": {
        "startTime": 337.0,
        "endTime": 345.5,
        "transcript": "Au͡g'um aanallma qanrutetullruanga unuakut iliitni kesianek pinrilnge'rmi.",
        "translation": "My late mother talked to me some morning, even if it wasn't all the time."
    },
    "68": {
        "startTime": 347.0,
        "endTime": 354.9,
        "transcript": "Pektesciigalilallruunga qalarutaqanga kesianek pinrilnge'rmi.",
        "translation": "I would become unable to move when she talked to me even though she didn't do it all the time."
    },
    "69": {
        "startTime": 355.0,
        "endTime": 358.9,
        "transcript": "Mat'um nalliini qanelriamek niicuirutua.",
        "translation": "These days, I don't hear people speaking [to the young people]."
    },
    "70": {
        "startTime": 360.0,
        "endTime": 363.9,
        "transcript": "Wangkuta-wa tua-i ciulirnerurtellriani nipngami.",
        "translation": "It's because we who have become elders have gone out."
    },
    "71": {
        "startTime": 364.0,
        "endTime": 367.5,
        "transcript": "Qavalriatun ellirtuq man'a qanruyutvut.",
        "translation": "It's like our traditional wisdom is sleeping."
    },
    "72": {
        "startTime": 368.0,
        "endTime": 377.9,
        "transcript": "Man'a qanruyutvut, nunavut arcaqerluku, meq-llu kencikesqumaluku pitullruitkut.",
        "translation": "Our traditional wisdom, they would tell us to especially revere our land and the water."
    },
    "73": {
        "startTime": 380.0,
        "endTime": 381.9,
        "transcript": "Kencikluku.",
        "translation": "Revere it."
    },
    "74": {
        "startTime": 382.0,
        "endTime": 389.5,
        "transcript": "Wagg'uq-am waniw' tua-i ayuqucirtuatemta ayuqucia:",
        "translation": "This is what our teachings were like:"
    },
    "75": {
        "startTime": 391.0,
        "endTime": 393.5,
        "transcript": "Wangkuta-gguq-am qantamcetun pitarrluku.",
        "translation": "We should [treat it with as much respect] as our bowls."
    },
    "76": {
        "startTime": 394.0,
        "endTime": 396.5,
        "transcript": "Mat'um nalliini tuaten ellinrituq.",
        "translation": "These days, it's not like that."
    },
    "77": {
        "startTime": 397.0,
        "endTime": 398.9,
        "transcript": "Allaurtuq.",
        "translation": "It's become different."
    },
    "78": {
        "startTime": 400.0,
        "endTime": 403.0,
        "transcript": "Cauga tauna wani qantamcetun pitarrluku?",
        "translation": "What does it mean, as much as our own bowls?"
    },
    "79": {
        "startTime": 404.0,
        "endTime": 405.9,
        "transcript": "Waten tua-i taringela'arqa:",
        "translation": "This is how I understand it:"
    },
    "80": {
        "startTime": 407.0,
        "endTime": 410.9,
        "transcript": "Qantaput man'a wangkuta ner'aqamta",
        "translation": "Our bowls, when we eat"
    },
    "81": {
        "startTime": 411.0,
        "endTime": 416.9,
        "transcript": "Tamaani-w' ciuqvani qantangqetulliniami yuk atauciq qantani tua-i murilkelluku pillilria.",
        "translation": "It's probably because a person back then had one bowl that [s]he watched over."
    },
    "82": {
        "startTime": 417.0,
        "endTime": 420.0,
        "transcript": "Kenekluku tua-i, kencikluku.",
        "translation": "[S]he loved and revered it."
    },
    "83": {
        "startTime": 422.0,
        "endTime": 425.0,
        "transcript": "Cuqyutekluku-am wiinga tamana pilaryukaqa",
        "translation": "I think that that was a metaphor"
    },
    "84": {
        "startTime": 427.0,
        "endTime": 432.0,
        "transcript": "Nunavut meq-llu kencikesqelluku wangkuta qantamcetun pitarrluku.",
        "translation": "To revere our land and the water as much as our bowls."
    },
    "85": {
        "startTime": 433.0,
        "endTime": 437.0,
        "transcript": "Au͡gkut yullret tua-i man'a ilii qanruyutiit.",
        "translation": "That's one piece of traditional wisdom from the people of old."
    },
    "86": {
        "startTime": 439.5,
        "endTime": 445.0,
        "transcript": "Cali-llu qantullrulriit-am",
        "translation": "They also used to say"
    },
    "87": {
        "startTime": 451.0,
        "endTime": 459.0,
        "transcript": "Tan'gaurluq waten nasaurlurmek aipirtuasqevkenaku arnamek tegupailgan.",
        "translation": "That a boy should not have relations with a girl before taking a woman [as a wife]."
    },
    "88": {
        "startTime": 460.9,
        "endTime": 464.9,
        "transcript": "Wangkuta, wangkuta mat'um nalliini navguagukut wangkutnek.",
        "translation": "We these days are destroying ourselves."
    },
    "89": {
        "startTime": 465.0,
        "endTime": 469.0,
        "transcript": "Unguvarput una navgualliniarput, temvut-llu una navgualliniarput.",
        "translation": "We are apparently destoring our lives, and destroying our bodies."
    },
    "90": {
        "startTime": 469.5,
        "endTime": 474.9,
        "transcript": "Mat'ukun-llu wiinga aturyulallruaqa cakneq man'a taangaq.",
        "translation": "And through this alcohol that I heavily abused."
    },
    "91": {
        "startTime": 476.0,
        "endTime": 479.9,
        "transcript": "Tamaa-i tamana uum tememta navguateklinia.",
        "translation": "That is evidently something that destroys our bodies."
    },
    "92": {
        "startTime": 481.0,
        "endTime": 490.0,
        "transcript": "Cali-llu tua-i-wa yuk cacurlagqami alaitelartuq nuna tamiini.",
        "translation": "Also, when a person misbehaves, it is visible in all the land."
    },
    "93": {
        "startTime": 491.0,
        "endTime": 493.9,
        "transcript": "Tamaani arcaqerluni.",
        "translation": "Especially back then."
    },
    "94": {
        "startTime": 496.0,
        "endTime": 498.9,
        "transcript": "Arcaqerluni inerciigatellrunricaaqngameng tamaani",
        "translation": "Because they were especially well-behaved back then"
    },
    "95": {
        "startTime": 500.0,
        "endTime": 503.0,
        "transcript": "Iliini piqalria mistutullruuq.",
        "translation": "One who occasionally [misbehaved] was clearly noticable."
    },
    "96": {
        "startTime": 505.0,
        "endTime": 510.0,
        "transcript": "Mat'um nalliini unuaquaqan ping'e'rmi qaillun wangkuta ellirtukut.",
        "translation": "These days, though it happens every day, we have become [worse]."
    },
    "97": {
        "startTime": 511.0,
        "endTime": 513.9,
        "transcript": "Wangkuta-ll' tua-i tegganerni camek qanyuirucamta.",
        "translation": "It's also because we elders do not say anything anymore."
    },
    "98": {
        "startTime": 514.0,
        "endTime": 520.9,
        "transcript": "Avani ciuqvaarni qanqautetullruit amllermek pinrilnge'rmegteki.",
        "translation": "Back then, they used to talk to [the young people], even if they didn't say a lot."
    },
    "99": {
        "startTime": 521.0,
        "endTime": 523.0,
        "transcript": "Tua-i anglanitekevkenateng.",
        "translation": "They didn't do it excessively."
    },
    "100": {
        "startTime": 525.5,
        "endTime": 529.9,
        "transcript": "Qasgimi-llu cali quyurcelluta iliini qanqautetullruitkut.",
        "translation": "They would also sometimes gather us in the community house and speak to us."
    },
    "101": {
        "startTime": 532.0,
        "endTime": 542.0,
        "transcript": "Cali-llu yaani Moravian-aat ciuqliit au͡gkut Kass'at quyurrluta iliini qalarutetullruitkut.",
        "translation": "And over there, the first Caucasian Moravians would sometimes gather us and speak to us."
    },
    "102": {
        "startTime": 544.0,
        "endTime": 547.9,
        "transcript": "Mat'um nalliini tayima pilaryaaqut.",
        "translation": "These days, they probably do that sometimes."
    },
    "103": {
        "startTime": 548.0,
        "endTime": 555.9,
        "transcript": "Tau͡gaam-am wii tamaa-i qitevquralriit taringesciigalikenka arcariluki",
        "translation": "But my inability to understand English is getting worse"
    },
    "104": {
        "startTime": 556.0,
        "endTime": 558.0,
        "transcript": "Taringecuaqatullrungramki maa-i.",
        "translation": "Even though I understand a little now."
    },
    "105": {
        "startTime": 558.5,
        "endTime": 562.0,
        "transcript": "Uum-llu niicuirutellma arcaqeryugnarqekiinga.",
        "translation": "My deteriorating hearing is probably making it worse for me."
    },
    "106": {
        "startTime": 564.0,
        "endTime": 566.0,
        "transcript": "Qitevqurluteng-llu piyaurcameng.",
        "translation": "They've started speaking mostly in English now."
    },
    "107": {
        "startTime": 567.0,
        "endTime": 572.0,
        "transcript": "Elpeci tau͡gaam ayagyuani tayima elisngaksi tamana.",
        "translation": "But youpl young people know that well."
    },
    "108": {
        "startTime": 573.0,
        "endTime": 576.0,
        "transcript": "Wangkuta ciuqvaarni avani elluarrluta elitnaurumanrilamta",
        "translation": "Because we back then did not have a thorough education"
    },
    "109": {
        "startTime": 576.5,
        "endTime": 580.5,
        "transcript": "Qitevquralriit tang wiinga taringyuitanka",
        "translation": "I don't understand people who speak completely in English"
    },
    "110": {
        "startTime": 582.0,
        "endTime": 586.0,
        "transcript": "Ilait tua-i agtuqa'aqluki piurangramki.",
        "translation": "Even though I touch on some of them."
    },
    "111": {
        "startTime": 592.0,
        "endTime": 594.9,
        "transcript": "Tua-i-wa aptaqluten pinga.",
        "translation": "Ask me questions."
    },
    "112": {
        "startTime": 595.0,
        "endTime": 597.0,
        "transcript": "Nallunqurruunga wii.",
        "translation": "I am the most ignorant."
    },
    "113": {
        "startTime": 600.0,
        "endTime": 604.0,
        "transcript": "Yaa, camek tayima umyuaqellerpenek",
        "translation": "Okay, something that you can think of"
    },
    "114": {
        "startTime": 606.0,
        "endTime": 609.9,
        "transcript": "Umyuaqellerpenek wani qanruyutmek ataucimek",
        "translation": "One piece of traditional wisdom that you can think of"
    },
    "115": {
        "startTime": 610.0,
        "endTime": 614.0,
        "transcript": "Wall'u qavcinek tayima umyuaqellerpenek qanrutqerkut.",
        "translation": "Or please tell us several that you can think of."
    },
    "116": {
        "startTime": 615.0,
        "endTime": 621.9,
        "transcript": "Tua-i-w' avani man'a ava-i arcaqerluku pitullrukiit:",
        "translation": "Back then, this was the most important one they said:"
    },
    "117": {
        "startTime": 624.0,
        "endTime": 632.0,
        "transcript": "Makut-llu tangnerrlugnaqellriit-wa tua-i makut pisciigalnguut-llu ikayuasqelluki pitullruitkut.",
        "translation": "They would tell us to help these people that were struggling or that were unable."
    },
    "118": {
        "startTime": 633.0,
        "endTime": 640.0,
        "transcript": "Cali-llu tangnerrlugnarqengraan yuk temciarautekesqenritaat angurrluk'.",
        "translation": "Also, they said not to make fun of anyone even if they were struggling under any circumstances."
    },
    "119": {
        "startTime": 641.0,
        "endTime": 642.0,
        "transcript": "Assiicugnarquq tamana.",
        "translation": "That is probably bad."
    },
    "120": {
        "startTime": 645.0,
        "endTime": 651.9,
        "transcript": "Tau͡gaam ikayuangnaqluki makut ak'allaraat pisciigalnguut pisqetullruit.",
        "translation": "They told them to instead help these older people who were unable."
    },
    "121": {
        "startTime": 654.0,
        "endTime": 656.0,
        "transcript": "Yuum-gguq umyugaa tukniuq.",
        "translation": "They said that a person's mind is powerful."
    },
    "122": {
        "startTime": 659.0,
        "endTime": 662.9,
        "transcript": "Cali-llu enemun allamun itengramta",
        "translation": "Also, even if we entered another house"
    },
    "123": {
        "startTime": 663.0,
        "endTime": 667.9,
        "transcript": "Agu kenrraungraan, ussukcarraungraan-ll', ataucirraungraan",
        "translation": "Under any circumstances, even a match, a nail, or a single thing"
    },
    "124": {
        "startTime": 668.0,
        "endTime": 671.0,
        "transcript": "Tamaaken enemek teguqautesqevkenii qanrutetullruanga au͡g'um.",
        "translation": "He used to tell me not to take anything from that house."
    },
    "125": {
        "startTime": 674.0,
        "endTime": 676.0,
        "transcript": "Qaillun pitaa?",
        "translation": "How much is it [now]?"
    },
    "126": {
        "startTime": 677.0,
        "endTime": 685.0,
        "transcript": "Cali-llu-gguq yuilqumun, yuilqumi tua-i yuum-gguq ellillni nalluyaguicuitaa",
        "translation": "They also said that in the wilderness, a person does not forget what [s]he put in the wilderness"
    },
    "127": {
        "startTime": 686.0,
        "endTime": 687.0,
        "transcript": "Yuilqurrungraan.",
        "translation": "Even if it's the wilderness."
    },
    "128": {
        "startTime": 687.9,
        "endTime": 689.0,
        "transcript": "Ilumun tamana piciuyugnarquq.",
        "translation": "That is probably true."
    },
    "129": {
        "startTime": 692.0,
        "endTime": 696.0,
        "transcript": "Yuilqurrungraan yuum ellillni nalluyagucuitniluku.",
        "translation": "They said that a person does not forget what [s]he put even in the wilderness."
    },
    "130": {
        "startTime": 698.0,
        "endTime": 701.0,
        "transcript": "Au͡g'umek ava-i aptarpenga arcaqalriamek.",
        "translation": "You just asked me about something important."
    },
    "131": {
        "startTime": 702.0,
        "endTime": 704.9,
        "transcript": "Au͡g'um qanrutestema piu͡rlutullruanga",
        "translation": "My instructor always used to tell me"
    },
    "132": {
        "startTime": 705.0,
        "endTime": 710.0,
        "transcript": "Agu watqapiar tangnerrlungnarqengraan temciarautekqaasqevkenaku.",
        "translation": "To never under any circumstances make fun of anyone struggling."
    },
    "133": {
        "startTime": 711.0,
        "endTime": 714.0,
        "transcript": "Tau͡gaam pisciigalnguq ikayuasqelluku",
        "translation": "He said to help someone that was unable instead"
    },
    "134": {
        "startTime": 715.0,
        "endTime": 718.0,
        "transcript": "Camek akimek nunuliutmek qanerpek'nii.",
        "translation": "Without talking about money for payment."
    },
    "135": {
        "startTime": 721.0,
        "endTime": 728.9,
        "transcript": "Ciin-mi, ciin-mi aaruteksiyaalallrulliniatgu tan'gaurluq arniuresqevkenaku?",
        "translation": "But why did they warn so much against boys having sexual relations with women?"
    },
    "136": {
        "startTime": 729.0,
        "endTime": 730.0,
        "transcript": "Camek kangilirluku pillruatgu?",
        "translation": "What was the meaning behind it?"
    },
    "137": {
        "startTime": 730.1,
        "endTime": 733.0,
        "transcript": "Waten-am kangilingqertuq, kangilingqelliniuq:",
        "translation": "This is the meaning behind it:"
    },
    "138": {
        "startTime": 734.0,
        "endTime": 735.0,
        "transcript": "Arnaq-gguq tuquuguq.",
        "translation": "They said that a woman is death."
    },
    "139": {
        "startTime": 740.0,
        "endTime": 746.0,
        "transcript": "Wiinga iliini pingnaqaqama nangtequagaqama-llu imumi",
        "translation": "When I strived sometimes, and would suffer back then"
    },
    "140": {
        "startTime": 746.5,
        "endTime": 753.0,
        "transcript": "Yuilqumi-ll' picuileng'e'rma-ll' yuilqumun uitalqa assikenrutullruamku",
        "translation": "And being in the wilderness though I didn't catch much because I liked being in the wilderness better"
    },
    "141": {
        "startTime": 754.0,
        "endTime": 756.0,
        "transcript": "Umyuarteq'lartua iliini piyuilliqaqama:",
        "translation": "I would sometimes think when I couldn't catch anything:"
    },
    "142": {
        "startTime": 756.5,
        "endTime": 760.0,
        "transcript": "“Wall' ima-qaa man'a pitengnaq'lalqa pitekluku",
        "translation": "“Well now, was it for my hunting"
    },
    "143": {
        "startTime": 761.0,
        "endTime": 764.9,
        "transcript": "“Waten qanrucimalallrullilrianga arnaq tuquuniluku?”",
        "translation": "“That I was told like this that a woman is death?”"
    },
    "144": {
        "startTime": 766.0,
        "endTime": 772.0,
        "transcript": "Inerciigatellruama wiinga piciatun tua-i pilallruunga.",
        "translation": "Because I was mischievous, I did various [mischievous] things."
    },
    "145": {
        "startTime": 773.0,
        "endTime": 777.9,
        "transcript": "Umyuarteq'lallruunga, “Mat'umek-ll' ima-qaa picirluteng inerqularyaaqellikiitnga",
        "translation": "I used to think, “Well now, was this why they admonished me"
    },
    "146": {
        "startTime": 778.0,
        "endTime": 782.9,
        "transcript": "“Piyuilliqlerkamek waten yuilqumi makunek-llu pitengnaqlemek?”",
        "translation": "“Because I would be unable to catch these things I was hunting in the wilderness?”"
    },
    "147": {
        "startTime": 786.0,
        "endTime": 788.9,
        "transcript": "Iqlunritamken ava-i. Inerciigatellruunga.",
        "translation": "I told you the truth. I was mischievous."
    },
    "148": {
        "startTime": 791.0,
        "endTime": 798.0,
        "transcript": "Yuum ilii qanerciryalleq murilkura'arqamni maa-i elluarrluni yuulartuq.",
        "translation": "In my observation, an obedient person lives well."
    },
    "149": {
        "startTime": 801.9,
        "endTime": 808.0,
        "transcript": "Angayuqaagmi qanellrak maligtaqustii nallunaunani elluarrluni yuulartuq.",
        "translation": "It's clear who obeys what their parents say and lives well."
    },
    "150": {
        "startTime": 810.0,
        "endTime": 812.9,
        "transcript": "Cali-llu camek enuqitenrilnganani.",
        "translation": "[S]he also doesn't seem to be in need of anything."
    },
    "151": {
        "startTime": 813.5,
        "endTime": 816.5,
        "transcript": "Tua-i-w' qanruyutni elliin maligtaquamiu.",
        "translation": "It's because [s]he listens to the traditional wisdom [s]he heard."
    },
    "152": {
        "startTime": 818.0,
        "endTime": 824.0,
        "transcript": "Wangtun tam' ayuqellria qanruyutem maligtaqunritestii wangtun tua-i ayuquq tua-i",
        "translation": "Someone like me who does not obey traditional is wisdom is like me"
    },
    "153": {
        "startTime": 825.0,
        "endTime": 827.9,
        "transcript": "Camek enuqitarluni kesianek.",
        "translation": "Always in need of things."
    },
    "154": {
        "startTime": 831.0,
        "endTime": 836.9,
        "transcript": "Man'a-am qaneryaraq man'a Yugtaq maa-i umyuarteqlemni",
        "translation": "In my opinion, this Yup'ik wisdom"
    },
    "155": {
        "startTime": 837.0,
        "endTime": 846.0,
        "transcript": "Makunun Bible-aam qanellranun, qanellratun cangallrunrituq.",
        "translation": "Is no different from what the Bible says."
    },
    "156": {
        "startTime": 847.0,
        "endTime": 852.9,
        "transcript": "Aug͡kut ciullrurluut Ellam-llu Yuanek qantullruameng.",
        "translation": "It's because the dear ancestors of old would talk about the Spirit of the Universe."
    },
    "157": {
        "startTime": 855.0,
        "endTime": 864.0,
        "transcript": "Nall'arrluku Bible-aat kingunrat man'a Atavut Qilametellria tayim' tangvaumanrilnguq.",
        "translation": "It corresponded with the origin of the Bible, our unseen Heavenly Father."
    },
    "158": {
        "startTime": 865.0,
        "endTime": 866.0,
        "transcript": "Tauna nall'arrluku.",
        "translation": "It corresponded with that."
    },
    "159": {
        "startTime": 866.5,
        "endTime": 869.0,
        "transcript": "Nallurlung'e'rmeng-am pitullrulliniat Ellam Yuanek.",
        "translation": "Though the poor people didn't know, they called it the Spirit of the Universe."
    },
    "160": {
        "startTime": 871.0,
        "endTime": 875.0,
        "transcript": "Ellam-llu Yuanun anucimirqecetaarciqniluta qantullruut.",
        "translation": "They also said that the Spirit of the Universe would tell us to repent."
    },
    "161": {
        "startTime": 878.0,
        "endTime": 884.9,
        "transcript": "Tua-i waniwa au͡gna arcaqerluku au͡g'urluum qanrutestekellma qantullruuq",
        "translation": "My poor teacher would especially say"
    },
    "162": {
        "startTime": 886.0,
        "endTime": 891.0,
        "transcript": "Tangnerrlugnarqellriamek agurrluk' watqapiar temciarautekesqevkenii.",
        "translation": "That I should never under any circumstances make fun of anyone struggling."
    },
    "163": {
        "startTime": 892.0,
        "endTime": 896.0,
        "transcript": "Tau͡gaam ikayuasqelluku pisciigalnguq.",
        "translation": "I should instead help whomever is unable."
    },
    "164": {
        "startTime": 897.0,
        "endTime": 899.0,
        "transcript": "Yuum-gguq umyugaa tukniuq.",
        "translation": "He said that a person's mind is powerful."
    },
    "165": {
        "startTime": 900.0,
        "endTime": 902.0,
        "transcript": "Waten qanqalartuq.",
        "translation": "This is what he would say."
    },
    "166": {
        "startTime": 903.5,
        "endTime": 905.0,
        "transcript": "Ilumun piciuluni.",
        "translation": "It is true."
    },
    "167": {
        "startTime": 906.0,
        "endTime": 914.0,
        "transcript": "Nunami tamarmi qaneryarallgutkenrilengramta qanruyutvut atauciuyaaqngatliniuq.",
        "translation": "It seems that in all the land, though we don't have the same language, our traditional wisdom is one."
    },
    "168": {
        "startTime": 915.0,
        "endTime": 917.9,
        "transcript": "Tau͡gaam yuum cali amllerem maa-i atunriraa.",
        "translation": "But many people also don't adhere to them anymore."
    },
    "169": {
        "startTime": 918.0,
        "endTime": 922.0,
        "transcript": "Wangkuta-w' tua-i ciulirnerurtellriani qanyuirucamta.",
        "translation": "It's because we who have become elders do not speak anymore."
    },
    "170": {
        "startTime": 924.0,
        "endTime": 929.0,
        "transcript": "Tuqulriatun ayuquq qanrutestailami, qanrutkenrilami.",
        "translation": "It's like it's dead because no one talks about it."
    },
    "171": {
        "startTime": 933.0,
        "endTime": 936.0,
        "transcript": "Tau͡gaam tua-i waten elpeci elliungluci",
        "translation": "But youpl have started doing this"
    },
    "172": {
        "startTime": 937.0,
        "endTime": 945.0,
        "transcript": "Waten-llu makuni apqaitni TV-ni tangrraqama quyamalartua waten qanelrianek.",
        "translation": "And I am thankful when I see people speaking [traditional wisdom] on what they call the TV."
    },
    "173": {
        "startTime": 946.0,
        "endTime": 948.0,
        "transcript": "Wiinga elluarrlua pinricaaqua waniwa.",
        "translation": "I am not doing well right now."
    },
    "174": {
        "startTime": 949.0,
        "endTime": 960.0,
        "transcript": "Ukurmiuni avaqlimteńi Urucararmiuni ukunek Kass'anek tangvagluta ellangamta",
        "translation": "Because we of Urucararmiut around here grew up watching Caucasians"
    },
    "175": {
        "startTime": 961.0,
        "endTime": 966.5,
        "transcript": "Murilkessagucamta avaqlimcetun ava-i ayuqenritukut wangkuta.",
        "translation": "Because we started observing them, we are not like those around us."
    },
    "176": {
        "startTime": 967.0,
        "endTime": 972.0,
        "transcript": "Avaqliput tau͡gaam maa-i makut elluarrluteng tangvallret",
        "translation": "But because those around us watched well"
    },
    "177": {
        "startTime": 973.0,
        "endTime": 976.9,
        "transcript": "Qasgimi-llu qavarturluteng pitullrulliniameng maa-i",
        "translation": "And because they would always sleep in the community house"
    },
    "178": {
        "startTime": 977.0,
        "endTime": 981.0,
        "transcript": "Tamaani tan'gaurluullemni wii niirqellemni ava-i",
        "translation": "From what I heard back when I was a boy"
    },
    "179": {
        "startTime": 982.0,
        "endTime": 987.0,
        "transcript": "Eneni qavayuunateng tan'gaurluut, qasgirrlainarmi tau͡gaam.",
        "translation": "The boys wouldn't sleep in houses, only in the community house."
    },
    "180": {
        "startTime": 988.5,
        "endTime": 992.0,
        "transcript": "Cali-llu niitelqa tamaani qasgimi",
        "translation": "Also, from what I heard about the community house back then"
    },
    "181": {
        "startTime": 995.0,
        "endTime": 1004.0,
        "transcript": "Erpailgan ciulirneq, ciulirneq-wa tua-i iliit qanerturatullrulliniami",
        "translation": "Before dawn, because one of the elders would always speak"
    },
    "182": {
        "startTime": 1005.0,
        "endTime": 1008.9,
        "transcript": "Tan'gerem iluani tua-i tupagaqameng.",
        "translation": "In the darkness when they woke up."
    },
    "183": {
        "startTime": 1009.0,
        "endTime": 1017.9,
        "transcript": "Tamaa-i tamaani ciuliaput elluarrluteng yuungatellrulliniut anglaninrilnge'rmeng.",
        "translation": "It seems that our ancestors back then lived well though they weren't frivolous."
    },
    "184": {
        "startTime": 1018.0,
        "endTime": 1022.0,
        "transcript": "Waten wangkucicetun maa-i mat'um nalliini anglinriatun ellirtukut.",
        "translation": "These days, we have become frivolous like this."
    },
    "185": {
        "startTime": 1023.0,
        "endTime": 1025.0,
        "transcript": "Waten ayuqellrunritukut",
        "translation": "We weren't like this"
    },
    "186": {
        "startTime": 1026.0,
        "endTime": 1029.9,
        "transcript": "Ca tamalkuan anglinillrunrituq.",
        "translation": "Nothing was taken lightly."
    },
    "187": {
        "startTime": 1031.5,
        "endTime": 1035.5,
        "transcript": "Neqa-llu, neqkun-llu man'a Kass'artaq anglanarqellrunrituq.",
        "translation": "And food, Western food was not in excess."
    },
    "188": {
        "startTime": 1036.5,
        "endTime": 1039.5,
        "transcript": "Enuqliqu'urrlainarnganani ayuqucingqellrulliniuq.",
        "translation": "It seems that it was always scarce."
    },
    "189": {
        "startTime": 1040.0,
        "endTime": 1045.0,
        "transcript": "Mat'um nalliini maa-i unuaquaqan sun'icaurtaakut tengssuutmek au͡gkunek.",
        "translation": "These days, those planes bring us cargo every day."
    },
    "190": {
        "startTime": 1045.5,
        "endTime": 1052.0,
        "transcript": "Avani malrurqurrlainaagnek tua-i sun'it'laraat up'nerkami uksuarmi-llu.",
        "translation": "Back then, they would only bring them cargo twice, in the spring and fall."
    },
    "191": {
        "startTime": 1055.0,
        "endTime": 1061.0,
        "transcript": "Man'a tua-i Kusquqvak kangillilluku payugcecullrullinii, un'a-ll' unani Caninermek pitukiit.",
        "translation": "It would bring stuff all the way to the mouth of the Kuskokwim, and what they call Canineq down there."
    },
    "192": {
        "startTime": 1063.0,
        "endTime": 1067.0,
        "transcript": "Sun'agnek malrugnek up'nerkami, uksuarmi.",
        "translation": "Only two barges in the spring, fall."
    },
    "193": {
        "startTime": 1068.0,
        "endTime": 1073.0,
        "transcript": "Taumek ava-i au͡gkut tua-i yull'urluut, carrluaraat, Kassaunge'rmeng-llu",
        "translation": "That's why those Yupiit of old, no matter who they were, even Caucasians."
    },
    "194": {
        "startTime": 1074.0,
        "endTime": 1079.0,
        "transcript": "Murilkeńganaku anglanitekevkenaku-llu pitullrulriit.",
        "translation": "They carefully watched and didn't take things lightly."
    },
    "195": {
        "startTime": 1081.0,
        "endTime": 1086.0,
        "transcript": "Au͡gkut ciuliaput Kass'amek qanyuitut amlleq, mine-anek tau͡gaam.",
        "translation": "Our ancestors back then wouldn't talk about Western things, only mines."
    },
    "196": {
        "startTime": 1087.0,
        "endTime": 1091.0,
        "transcript": "Kass'aq tua-i mine-amek piaqluku, mine-allernek-llu qanraqluteng.",
        "translation": "They would call the Western thing a mine, and they would talk about old mines."
    },
    "197": {
        "startTime": 1092.0,
        "endTime": 1095.0,
        "transcript": "Kass'amek qanerpakayuitut wiinga murilkellemni maani.",
        "translation": "They didn't speak too much about Western things here in my observation."
    },
    "198": {
        "startTime": 1096.0,
        "endTime": 1097.9,
        "transcript": "Tua-i-wa mat'umek pilaryukanka:",
        "translation": "This is what I think they did:"
    },
    "199": {
        "startTime": 1098.0,
        "endTime": 1102.0,
        "transcript": "Au͡gkut Kass'at akinek yuarturalallret pitekluku tamaani.",
        "translation": "Those Caucasians were looking to make money back then."
    },
    "200": {
        "startTime": 1103.0,
        "endTime": 1106.0,
        "transcript": "Caliarkaq enurnallruuq tamatum nalliini.",
        "translation": "There were not many jobs at that time."
    },
    "201": {
        "startTime": 1109.0,
        "endTime": 1117.0,
        "transcript": "Neqsurarang'e'rmeng cali neqalleruaq man'a akikurluku, ima-llu-q' akituaqluni?",
        "translation": "Though they always fished, this fish was their currency, and wasn't it expensive?"
    },
    "202": {
        "startTime": 1119.0,
        "endTime": 1124.0,
        "transcript": "Ataucirqumek murilkellemni iqalluuk malruk waten kangirassullrulriik.",
        "translation": "Once in my observation, two chums like this cost two quarters."
    },
    "203": {
        "startTime": 1127.0,
        "endTime": 1131.0,
        "transcript": "Tamaani nalliini cat akitullrunritut tau͡gaam.",
        "translation": "But things were not expensive at that time."
    },
    "204": {
        "startTime": 1134.0,
        "endTime": 1136.0,
        "transcript": "Tau͡gaam enurnarluni wani Kass'aq.",
        "translation": "But Western things were scarce."
    },
    "205": {
        "startTime": 1137.0,
        "endTime": 1142.0,
        "transcript": "Kass'am pia amllerpek'nani, watuam nalliitun ayuqevkenani.",
        "translation": "There weren't many Western things, not like now."
    },
    "206": {
        "startTime": 1144.0,
        "endTime": 1151.0,
        "transcript": "Tua-i call' kenurraraqluteng imkunek kerosene-anek pikait, pilaqait",
        "translation": "They also had lights with what they called kerosene"
    },
    "207": {
        "startTime": 1152.0,
        "endTime": 1154.0,
        "transcript": "Tan'geriaqan tau͡gaam.",
        "translation": "Only when it got dark."
    },
    "208": {
        "startTime": 1156.0,
        "endTime": 1160.0,
        "transcript": "Anglaniu͡rlullrunritut au͡gkut ciuqvani tangvallrenka ca tamalkuan.",
        "translation": "The poor people I saw back then did not take anything lightly."
    },
    "209": {
        "startTime": 1162.0,
        "endTime": 1169.0,
        "transcript": "Tau͡gaam man'a Yugtaq neqa nangyaqnganaku yuullruut piitellerkaa.",
        "translation": "But they lived seemingly in fear that this Yup'ik food would become scarce."
    },
    "210": {
        "startTime": 1171.0,
        "endTime": 1177.9,
        "transcript": "Au͡g'um-llu qanrutesteḿa pitullrukiinga neqem nalliini qavaasqevkenii.",
        "translation": "My instructor also used to tell me not to sleep during food gathering season."
    },
    "211": {
        "startTime": 1179.0,
        "endTime": 1181.0,
        "transcript": "Uksurpak qavallerkaqa amllerrniluku.",
        "translation": "He said that I had a lot of time to sleep all winter."
    },
    "212": {
        "startTime": 1183.0,
        "endTime": 1186.9,
        "transcript": "Tau͡gaam wiinga maligtaqunritaqa tamana inerciigalama.",
        "translation": "But I didn't obey him because I was mischievous."
    },
    "213": {
        "startTime": 1188.0,
        "endTime": 1196.9,
        "transcript": "Tua-i neqsuqalang'e'rma mat'um nalliini tuaten pitanritukut, amlleq-wa.",
        "translation": "Though I fish, we are not like that these days, at least most of us."
    },
    "214": {
        "startTime": 1198.0,
        "endTime": 1201.9,
        "transcript": "Yaa, tua-i-w' sass'aqa wani mallgingelria.",
        "translation": "Well, my time is nigh."
    },
    "215": {
        "startTime": 1202.0,
        "endTime": 1204.9,
        "transcript": "Qanemcillerkaqa mallginguq.",
        "translation": "It's almost time for me to go on air."
    },
    "216": {
        "startTime": 1205.0,
        "endTime": 1212.9,
        "transcript": "Agayuvigmi agayuyarturangnaqengllemni-wa man'a taangaq taqlemni kinguakun",
        "translation": "In the church, when I started trying to go to church after I quit drinking alcohol"
    },
    "217": {
        "startTime": 1213.0,
        "endTime": 1221.0,
        "transcript": "Taangamek taqellma kinguani agayuyarturangnaq'lallruunga caperrsukapiarang'e'rma.",
        "translation": "After I quit drinking alcohol, I tried to go to church though I felt very constrained."
    },
    "218": {
        "startTime": 1225.0,
        "endTime": 1230.0,
        "transcript": "Tua-i Agayunret cali miss-anritengnaqu'urluku.",
        "translation": "I tried not to miss any Sundays."
    },
    "219": {
        "startTime": 1231.0,
        "endTime": 1234.0,
        "transcript": "Maa-i-qaa kuluk'uunarteńguuten cali?",
        "translation": "Are you still a bell-ringer today?"
    },
    "220": {
        "startTime": 1235.0,
        "endTime": 1242.0,
        "transcript": "Tua-i piqerlua iliita unayaqaanga calisqellua tuani agayuvigmi.",
        "translation": "One day, one of them invited me to work in the church."
    },
    "221": {
        "startTime": 1243.0,
        "endTime": 1245.0,
        "transcript": "Pingraanga ciuqlirmi niitellrunritaqa",
        "translation": "Though he asked me, I refused him at first"
    },
    "222": {
        "startTime": 1246.0,
        "endTime": 1250.0,
        "transcript": "Tua-i-wa wii caperrsuglua man'a taangaq-llu cakneq atullruamku.",
        "translation": "Because I felt constrained since I abused alcohol so heavily."
    },
    "223": {
        "startTime": 1251.0,
        "endTime": 1259.0,
        "transcript": "Piqarraallemni tau͡gaam agayungnaqurallemni tamaa-i iliini unayaqumallruanga",
        "translation": "But when I first started trying to go to church back then, I would sometimes be invited"
    },
    "224": {
        "startTime": 1259.5,
        "endTime": 1266.0,
        "transcript": "Kesianek pivkenani aptaqlua agayuvigmi yaani ikayuqsugyaaqlua.",
        "translation": "He would ask me, not all the time, for me to help in the church over there."
    },
    "225": {
        "startTime": 1268.0,
        "endTime": 1272.0,
        "transcript": "Tua-i piqerlua caqerluku kiullruaqa",
        "translation": "One day, I answered him"
    },
    "226": {
        "startTime": 1275.0,
        "endTime": 1277.0,
        "transcript": "Ak'anun piyugpek'nii umyuarteqlua pillruaqa waten",
        "translation": "Thinking that I didn't want to do it for long, I said to him"
    },
    "227": {
        "startTime": 1278.0,
        "endTime": 1280.0,
        "transcript": "…ksaitaqa agayu[?].",
        "translation": "…I didn't [?] him [?] the church."
    },
    "228": {
        "startTime": 1284.0,
        "endTime": 1292.0,
        "transcript": "Cali akilitullruyaaqaatnga $50 iralumi.",
        "translation": "They also used to pay me $50 per month."
    },
    "229": {
        "startTime": 1292.5,
        "endTime": 1297.0,
        "transcript": "Tua-i-llu piqerlua raise-araatnga mayuqanirlua $100 iralumi.",
        "translation": "And then eventually, they gave me a raise to $100 per month."
    },
    "230": {
        "startTime": 1299.0,
        "endTime": 1301.0,
        "transcript": "Tua-i wiinga umyuarteqlemni",
        "translation": "In my opinion"
    },
    "231": {
        "startTime": 1303.0,
        "endTime": 1307.0,
        "transcript": "Man'a au͡gna kinguneqa umyuaqluku pillemni pilua umyuaqelaamku",
        "translation": "When I thought about my past because I remember it"
    }
};